const BannerCustom = ({status, message, onDismiss, onViewDetails}) => {
	const statusStyles = {
		success: {
			backgroundColor: "rgba(246, 254, 249, 1)",
			borderColor: "rgba(80, 174, 96, 1)",
			color: 'rgba(72, 159, 86, 1)',
			svgIcon: (
				<svg
					viewBox='0 0 20 20'
					focusable='false'
					aria-hidden='true'
					fill='rgba(80, 174, 96, 1)'
				><path
					fillRule='evenodd'
					d='M0 10a10 10 0 1 0 20 0 10 10 0 0 0-20 0zm15.2-1.8a1 1 0 0 0-1.4-1.4l-4.8 4.8-2.3-2.3a1 1 0 0 0-1.4 1.4l3 3c.4.4 1 .4 1.4 0l5.5-5.5z'
				></path ></svg >
			)
		},
		error: {
			backgroundColor: "rgba(255, 251, 250, 1)",
			borderColor: "rgba(240, 68, 56, 1)",
			color: 'rgba(145, 32, 24, 1)',
			svgIcon: (<svg
				viewBox='0 0 20 20'
				className='Polaris-Icon__Svg'
				focusable='false'
				aria-hidden='true'
				fill='rgba(240, 68, 56, 1)'
			><path d='M11.768.768a2.5 2.5 0 0 0-3.536 0l-7.464 7.464a2.5 2.5 0 0 0 0 3.536l7.464 7.464a2.5 2.5 0 0 0 3.536 0l7.464-7.464a2.5 2.5 0 0 0 0-3.536l-7.464-7.464zm-2.768 5.232a1 1 0 1 1 2 0v4a1 1 0 1 1-2 0v-4zm2 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0z'></path ></svg >)
		},
		critical: {
			backgroundColor: "rgba(255, 251, 250, 1)",
			borderColor: "rgba(240, 68, 56, 1)",
			color: 'rgba(145, 32, 24, 1)',
			svgIcon: (
				<svg
					viewBox='0 0 20 20'
					focusable='false'
					aria-hidden='true'
					fill='rgba(240, 68, 56, 1)'
				><path d='M11.768.768a2.5 2.5 0 0 0-3.536 0l-7.464 7.464a2.5 2.5 0 0 0 0 3.536l7.464 7.464a2.5 2.5 0 0 0 3.536 0l7.464-7.464a2.5 2.5 0 0 0 0-3.536l-7.464-7.464zm-2.768 5.232a1 1 0 1 1 2 0v4a1 1 0 1 1-2 0v-4zm2 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0z'></path ></svg >
			)
		},
		warning: {
			backgroundColor: "rgba(255, 251, 236, 1)",
			borderColor: "rgba(255, 213, 62, 1)",
			color: 'rgba(196, 50, 10, 1)',
			svgIcon: (
				<svg
					viewBox='0 0 20 20'
					className='Polaris-Icon__Svg'
					focusable='false'
					aria-hidden='true'
					fill='rgba(255, 213, 62, 1)'
				><path
					fillRule='evenodd'
					d='M10 0c-5.514 0-10 4.486-10 10s4.486 10 10 10 10-4.486 10-10-4.486-10-10-10zm-1 6a1 1 0 1 1 2 0v4a1 1 0 1 1-2 0v-4zm1 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2z'
				></path ></svg >
			)
		},
		info: {
			backgroundColor: "rgba(239, 248, 255, 1)",
			borderColor: "rgba(23, 92, 211, 1)",
			color: 'rgba(24, 73, 169, 1)',
			svgIcon: (<svg
				width='20'
				height='20'
				viewBox='0 0 20 20'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
			>
			<path
				d='M10 9C9.73479 9 9.48043 9.10536 9.2929 9.29289C9.10536 9.48043 9 9.73478 9 10V14C9 14.2652 9.10536 14.5196 9.2929 14.7071C9.48043 14.8946 9.73479 15 10 15C10.2652 15 10.5196 14.8946 10.7071 14.7071C10.8946 14.5196 11 14.2652 11 14V10C11 9.73478 10.8946 9.48043 10.7071 9.29289C10.5196 9.10536 10.2652 9 10 9ZM10.38 5.08C10.1365 4.97998 9.86347 4.97998 9.62 5.08C9.49725 5.12759 9.38511 5.19896 9.29 5.29C9.20167 5.3872 9.13065 5.49882 9.08 5.62C9.02402 5.73868 8.99662 5.86882 9 6C8.99924 6.13161 9.02447 6.26207 9.07423 6.38391C9.124 6.50574 9.19732 6.61656 9.29 6.71C9.38721 6.79833 9.49882 6.86936 9.62 6.92C9.7715 6.98224 9.93597 7.00632 10.099 6.99011C10.2619 6.97391 10.4184 6.91792 10.5547 6.82707C10.691 6.73622 10.8029 6.61328 10.8805 6.46907C10.9582 6.32486 10.9992 6.16378 11 6C10.9963 5.73523 10.8927 5.48163 10.71 5.29C10.6149 5.19896 10.5028 5.12759 10.38 5.08ZM10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17317C0.00433284 8.00043 -0.193701 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8079C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C20 8.68678 19.7413 7.38642 19.2388 6.17317C18.7363 4.95991 17.9997 3.85752 17.0711 2.92893C16.1425 2.00035 15.0401 1.26375 13.8268 0.761205C12.6136 0.258658 11.3132 0 10 0ZM10 18C8.41775 18 6.87104 17.5308 5.55544 16.6518C4.23985 15.7727 3.21447 14.5233 2.60897 13.0615C2.00347 11.5997 1.84504 9.99113 2.15372 8.43928C2.4624 6.88743 3.22433 5.46197 4.34315 4.34315C5.46197 3.22433 6.88743 2.4624 8.43928 2.15372C9.99113 1.84504 11.5997 2.00346 13.0615 2.60896C14.5233 3.21447 15.7727 4.23984 16.6518 5.55544C17.5308 6.87103 18 8.41775 18 10C18 12.1217 17.1572 14.1566 15.6569 15.6569C14.1566 17.1571 12.1217 18 10 18Z'
				fill='rgba(23, 92, 211, 1)'
			/>
			</svg >)
			
		},
	}
	
	const currentStatus = statusStyles[status] || statusStyles.info;

	return (
		<div
			style={{
				backgroundColor: currentStatus.backgroundColor,
				border: `1px solid ${currentStatus.borderColor}`,
				color: currentStatus.color,
				display: "flex",
				alignItems: "flex-start",
				padding: "12px 16px",
				borderRadius: "8px",
				gap: "8px",
				marginBottom: 10,
			}}
		>
      <div style={{width: "20px", height: "20px", display: 'flex', alignItems: 'center', justifyContent: 'center'}}>{currentStatus.svgIcon}</div >
      <div style={{flex: 1, display: 'flex', flexDirection: 'column', gap: '8px'}}>
				<div>{message}</div>
				{onViewDetails && (
					<button
						onClick={onViewDetails}
						style={{
							background: "none",
							border: "none",
							fontSize: "14px",
							cursor: "pointer",
							color: currentStatus.color,
							textDecoration: "underline",
							padding: 0,
							alignSelf: "flex-start",
							display: "flex",
							alignItems: "center",
							gap: "4px",
							fontFamily: "inherit",
						}}
					>
						View details
						<svg
							width="12"
							height="12"
							viewBox="0 0 12 12"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
							style={{ display: "inline-block", marginLeft: "2px" }}
						>
							<path
								d="M4.5 3L7.5 6L4.5 9"
								stroke="currentColor"
								strokeWidth="1.5"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
						</svg>
					</button>
				)}
			</div>
			{onDismiss && (
				<button
					className="banner-custom-close-button"
					onClick={() => {
						onDismiss();
					}}
					style={{
						background: "none",
						border: "none",
						fontSize: "16px",
						cursor: "pointer",
						color: currentStatus.color,
					}}
				>
          ×
        </button >
			)}
    </div >
	);
};

export default BannerCustom;
